import React from "react";
import "./CircularProgress.scss";

export const CircularProgress = (props) => {
  return (
    <div className={`pie-wrapper progress-${props.progress}`}>
      <span className="label">
        {props.progress}
        <span className="smaller">%</span>
      </span>
      <div className="pie">
        <div className="left-side half-circle"></div>
        <div className="right-side half-circle"></div>
      </div>
    </div>
  );
};
